import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CustomPagination from '../../../components/forms/Pagination';
import { formatDateString } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { RAGRecord } from '../types/RAGRecord';
import { ConfigurationName } from '../../../enums/ConfigurationName';
import { UserContext } from '../../../components/shared/useUser';
import useNswagClient from '../../../hooks/api/useNswagClient';
import useLogError from '../../../hooks/useLogError';
import { useEffect } from 'react';

export default function DenseTable(props: { 
  readonly list: RAGRecord[];
}) {
  const { t } = useTranslation('common');
  const [isDisplayPoDetailsEnabled, setIsDisplayPoDetailsEnabled] = React.useState<boolean>(false);
  const { selectedStore } = React.useContext(UserContext);
  const { getConfiguration } = useNswagClient();
  const { logError } = useLogError();
  const [page, setPage] = React.useState(0);
  const rowsPerPage = 10;

  const rows = props.list;

  useEffect(() => {
    checkConfig();
  }, []);

  const maxPages = () => {
    return Math.ceil(rows.length / rowsPerPage);
  };

  const visibleRows = () => {
    return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  };

  const checkConfig = () => {
    getConfiguration(ConfigurationName.DisplayPoDetails, selectedStore?.storeNumber ?? '', selectedStore?.franchiseName ?? '')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((config: any) => {
        if (config.data.value === 'true') {
          setIsDisplayPoDetailsEnabled(true);
        }
      })
      .catch((e) => logError(e));
  };

  return (
    <>
      <TableContainer component={'div'}>
        <Table
          size="small"
          aria-label="a table">
          <TableHead>
            <TableRow>
              <TableCell align="left">
                {t('date')}
              </TableCell>
              <TableCell align="left">
                {t('store')}
              </TableCell>
              {visibleRows().some(row => row.orderNumber ?? row.orderType  ?? row.orderId ) && (
                <>
                  <TableCell>
                    {t('orderNumber')}
                  </TableCell>
                  {isDisplayPoDetailsEnabled &&  <TableCell>
                    {t('orderId')}
                  </TableCell>}
                  <TableCell>
                    {t('purchaseOrderReceipt.orderType')}
                  </TableCell>
                </>
              )} 
              {visibleRows().some(row => row.name) && (
                <TableCell>
                  {t('stockCount')}
                </TableCell>
              )} 
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows().map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  {(!row.itemDate ? '' : formatDateString(row.itemDate, selectedStore?.franchiseName))}
                </TableCell>
                <TableCell align="left">
                  {row.storeName}
                </TableCell>
                {visibleRows().some(r => r.orderNumber ?? r.orderType ?? r.orderId) && (
                  <>
                    <TableCell>
                      {row.orderNumber ?? ''}
                    </TableCell>
                    {isDisplayPoDetailsEnabled &&  <TableCell>
                      {row.orderId ?? ''}
                    </TableCell>}
                    <TableCell>
                      {row.orderType ?? ''}
                    </TableCell>
                  </>
                )}  
                {visibleRows().some(row => row.name) && (
                  <TableCell>
                    {row.name ?? ''}
                  </TableCell>
                )} 
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        page={page}
        setPage={setPage}
        maxPages={maxPages()}
        breakpointForChangeDisplay={120000}
      ></CustomPagination>
    </>
  );
}
